module.exports = "//web.config";


//////////////////
// WEBPACK FOOTER
// ./src/web.config
// module id = 933
// module chunks = 0